(function($) {
  $(function($){
    $('.wpsbc-heading > span').each(function() {
      var text = $(this).text();
      var a = text.split('月 ');
      $(this).text(a[1] + '年 ' + a[0] + '月');
    });

    var $legend = $('.wpsbc-legend');

    $('.wpsbc-calendar').each(function() {
      $(this).append($legend.clone());
    });

    $legend.hide();

  });
})(jQuery);
